import { useContext, useEffect, useRef } from "react"
import { Subscription } from 'xstate';
import { useAnalytics } from "src/lib/analytics"
import { RedemptionContext } from "@dapperlabs/redeem.js"
import { setExceptionUser } from 'src/lib/sentry';

export function IdentifyUser () {
  const hasIdentifiedRef = useRef(false)
  const subscriptionRef = useRef<Subscription>(null)
  const { redemptionService } = useContext(RedemptionContext)
  const { alias, identify } = useAnalytics()

  useEffect(() => {
    subscriptionRef.current?.unsubscribe()
    subscriptionRef.current = redemptionService.subscribe((state) => {
      if (hasIdentifiedRef.current) return
      if (!state.context.user) return
      hasIdentifiedRef.current = true

      // identify for analytics
      alias(state.context.user.addr)
      identify(state.context.user.addr)

      // identify for sentry
      setExceptionUser(state.context.user.addr)
    })
    return () => subscriptionRef.current?.unsubscribe()
  }, [alias, identify, redemptionService])
  return null
}
